import { Packages } from '~shared/constants/pricing';

import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { FeatureListMap } from '~app/pages/Pricing/transformers/summary/types';

import AdvantageFeatureList from './advantageFeatureList';
import PremierFeatureList from './premierFeatureList';
import EnterpriseFeatureList from './enterpriseFeatureList';
import FormsFeatureList from './formsFeatureList';
import BasicFeatureList from './basicFeatureList';
import FeatureRulesT1T2 from './featureRulesT1T2';
import FeatureRulesT3 from './featureRulesT3';
/**
 * All feature list configuration mapping. See the FeatureListMap for how to set up the config object.
 * It is advisable to import experiment feature list config from the experiment subfolder of your experiment.
 * Failure to provide the correct config can result in incorrect UI and business logic presentation.
 * We also encourage all new package or package name change to define their own feature list.
 */
const Grow2792FeatureListMap: FeatureListMap = {
  [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment1]: {
    [Packages.FormsAnnual]: {
      list: FormsFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.FormsMonthly]: {
      list: FormsFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.AdvantageAnnual]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.AdvantageMonthly]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.TeamAdvantage]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.PremierAnnual]: {
      list: PremierFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.TeamPremier]: {
      list: PremierFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.Enterprise]: {
      list: EnterpriseFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
  },
  [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment2]: {
    [Packages.FormsAnnual]: {
      list: FormsFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.AdvantageAnnual]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.AdvantageMonthly]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.TeamAdvantage]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.PremierAnnual]: {
      list: PremierFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.TeamPremier]: {
      list: PremierFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
    [Packages.Enterprise]: {
      list: EnterpriseFeatureList,
      rules: FeatureRulesT1T2,
      includesDefaultList: true,
    },
  },
  [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment3]: {
    [Packages.Basic]: {
      list: BasicFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
    [Packages.AdvantageAnnual]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
    [Packages.AdvantageMonthly]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
    [Packages.TeamAdvantage]: {
      list: AdvantageFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
    [Packages.PremierAnnual]: {
      list: PremierFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
    [Packages.TeamPremier]: {
      list: PremierFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
    [Packages.Enterprise]: {
      list: EnterpriseFeatureList,
      rules: FeatureRulesT3,
      includesDefaultList: true,
    },
  },
};

export default Grow2792FeatureListMap;
